import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {View} from 'native-base';
import React, {ReactNode} from 'react';

import {FCC} from '../../../../types';

const OfferDetailsButtonsWrapper: React.FC<{children: ReactNode}> = ({
  children,
}) => {
  const isDesktop = useIsDesktop();
  return (
    <View
      p={isDesktop ? undefined : 4}
      backgroundColor="white"
      alignItems={isDesktop ? 'flex-end' : 'stretch'}
      justifyContent={isDesktop ? undefined : 'center'}>
      {children}
    </View>
  );
};

export default OfferDetailsButtonsWrapper;
